import { render, staticRenderFns } from "./AdminSemester.vue?vue&type=template&id=75093466&scoped=true"
import script from "./AdminSemester.vue?vue&type=script&lang=js"
export * from "./AdminSemester.vue?vue&type=script&lang=js"
import style0 from "./AdminSemester.vue?vue&type=style&index=0&id=75093466&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75093466",
  null
  
)

export default component.exports